import Icon from '../../components/icons';
import { publicAssetsPrefix } from '../../../../../configuration';

const clock = Icon({ type: 'clock', size: 15 });

const getColorByStatus = (status) => {
  switch (status.toLowerCase()) {
    case 'pending':
      return '#9c75f6';
    case 'screened_out':
      return '#ff0d3b';
    case 'success':
      return '#2fc772';
    default:
      return '#9c75f6';
  }
};
const ParticipationSurveyCard = (
  {
    pointsName = 'Points',
    pointsValue = 0,
    reward_offer_previous_value: rewardOfferPreviousValue = 0,
    loi = 0,
    surveyProvider = '',
    status = 'pending',
    reason,
    timestamp = Date.now(),
  },
  getText,
) => {
  const surveyProviderImage = `${publicAssetsPrefix}/img/${surveyProvider
    .toLowerCase()
    .replace(/\s/g, '')}.png`;
  const statusColor = getColorByStatus(status);
  const reasonText = getText(`offerwall.history.${reason}`);
  let statusText = getText('offerwall.history.pending');
  if (status === 'success') {
    statusText = getText('offerwall.history.rewarded');
  } else if (status === 'screened_out') {
    statusText = getText('offerwall.history.screened_out');
  }

  if (reasonText) {
    statusText = `${reasonText} - ${statusText}`;
  }

  let previousPointsTemplate = '';
  if (rewardOfferPreviousValue && rewardOfferPreviousValue > 0) {
    previousPointsTemplate = `<p class="text-sm margin-reset" style="text-decoration: line-through; color: #fb3b71;">${rewardOfferPreviousValue}</p>`;
  }

  return `
    <article class="flex-full-width card-v2 margin-sm-btm">
      <section class="card-v2-body">
        ${previousPointsTemplate}
        <header class="flex">
          <div class="flex-1">
            <p class="margin-reset"><b>${pointsValue}</b> ${pointsName}</p>
            <p class="font-bold margin-reset">${clock} ${loi} ${getText(
    'offerwall.surveyCard.minutes',
  )}</p>
          </div>
          <div class="text-align-right">
            <p class="margin-reset" style="color: ${statusColor}">${statusText}</p>
            <p class="margin-reset text-grey">${new Date(
              timestamp,
            ).toLocaleString()}</p>
          </div>
        </header>
      </section>
      <footer class="card-v2-footer">
        <div class="divider margin-md-btm"></div>
        <div class="flex flex-align-items--center">
          <span style="line-height: 1" class="text-sm">${getText(
            'surveyBy',
          )}:</span>
          <div class="margin-xs-horizontal">
            <img style="max-height: 15px; display: block;" src="${surveyProviderImage}" alt="${surveyProvider}" />
          </div>
        </div>
      </footer>
    </article>
  `;
};

export default ParticipationSurveyCard;
